module.exports = __webpack_public_path__ + "img/MELA_Mono.Macro.2ee654b5.png";